function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'components/Form/Button';
import Logout from 'svg/logout.svg';
import messages from '../../messages';
import * as actions from '../../actions';
import styles from './LogoutBtn.pcss';
var _React_PureComponent;
class LogoutBtn extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { className, onSignOut } = this.props;
        return /*#__PURE__*/ _jsxs(Button, {
            styleModifier: "primary",
            className: cn(className),
            onClick: onSignOut,
            children: [
                /*#__PURE__*/ _jsx(Logout, {
                    className: "btn__icon mr-3"
                }),
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.logout))
            ]
        });
    }
}
_define_property(LogoutBtn, "propTypes", {
    // Explicit props
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    // Implicit actions
    onSignOut: PropTypes.func
});
const mapDispatchToProps = (dispatch)=>({
        onSignOut: ()=>dispatch(actions.signOut())
    });
const ConnectedLogoutBtn = connect(null, mapDispatchToProps)(LogoutBtn);
export default withStyles(styles)(ConnectedLogoutBtn);
